<template>
  <img v-if="isImg" :alt="name" :src="src" :style="imageStyle" class="default" />
  <div v-else :style="backgroundStyle" class="default image-background"></div>
</template>

<script>
export const ImageType = Object.freeze({
  img: 'img',
  bg: 'bg'
})

export default {
  name: 'VImage',
  props: {
    type: {
      type: String,
      default: ImageType.img
    },
    src: {
      type: String,
      required: true
    },
    name: String,
    width: {
      type: Number,
      required: true
    },
    height: {
      type: Number,
      required: true
    },
    radius: {
      type: Number,
      default: 0
    }
  },
  computed: {
    isImg() {
      return this.type === ImageType.img
    },
    backgroundStyle() {
      return {
        backgroundImage: `url('${this.src}')`,
        width: `${this.width}px`,
        height: `${this.height}px`,
        borderRadius: `${this.radius}px`
      }
    },
    imageStyle() {
      return {
        width: `${this.width}px`,
        height: `${this.height}px`,
        borderRadius: `${this.radius}px`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.default {
  width: auto;
  height: auto;
  object-fit: contain;
}

.image-background {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
</style>